<template>
  <base-state-town-dialog
    :title="'room.param.town.title' | i18n"
    :subtitle="'room.param.town.subtitle' | i18n"
    :description="'room.param.town.description' | i18n"
    v-model="town" />
</template>


<script>
  import Vue from 'vue'
  import BaseStateTownDialog from "./BaseStateTownDialog"
  import townService from "../../api/townService";

  export default {
    computed: {
      town: {
        get() {
          return this.$store.state.roomParams.town
        },
        set(town) {
          this.$store.commit('roomParams/SET_TOWN', town)
        }
      }
    },

    created() {
      if(this.town == null) {
        this.$store.commit('roomParams/SET_TOWN', townService.getTownByCode('837'))
      }
    },

    components: {
      BaseStateTownDialog
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/RoomStateTownDialog.vue